export const baseApi = '/api/Gen/methods'
